/**
 * One policy for category defaults, asset overrides, depreciation and disposal,
 * including their pickers. An unlinked BANK role still denotes a bank account.
 * Reasons let each operation retain its own error status and provenance copy.
 */
export function fixedAssetAccountProblem(account, expected) {
    if (!account || account.ledgerId !== expected.ledgerId)
        return 'not-found';
    if (account.archivedAt !== null)
        return 'archived';
    if (account.section !== expected.section || account.bankAccountId !== null || account.systemRole === 'BANK') {
        return 'wrong-section-or-bank';
    }
    return null;
}
